import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { Box, Typography } from "@mui/material";
import Colors from "../../../../assets/styles";

const PropertyAnalyticsChart = ({ properties }) => {
  const chartData = properties.map((row) => ({
    name: row.property?.name,
    Bookings: row.totalBookings || 0,
    Agents: row.agentNames?.length || 0,
    Feedbacks: row.feedbackCount || 0,
  }));

  return (
    <Box
      sx={{
        mt: 3,
        p: 3,
        bgcolor: "#fff",
        borderRadius: 3,
        border: "1px solid #e3e3e3",
        boxShadow: "0 3px 8px rgba(0,0,0,0.06)",
      }}
    >
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          mb: 2,
          color: Colors.primary,
        }}
      >
        Property Performance Overview
      </Typography>

      <ResponsiveContainer width="100%" height={380}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend />

          <Bar dataKey="Bookings" fill="#1976d2" />
          <Bar dataKey="Agents" fill="#0288d1" />
          <Bar dataKey="Feedbacks" fill="#6a1b9a" />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default PropertyAnalyticsChart;